import { ChecklistBundle } from "../../../../hooks/use-arb";

export const getCAChecklistMappingDefault = ({ bundle }: { bundle: ChecklistBundle }) => {};
